const state = {
  landmarks: [],
  bounds: null,
};

const mutations = {
  SET_LANDMARKS(state, landmarks) {
    state.landmarks = landmarks;
  },
  SET_LANDMARK_BOUNDS(state, bounds) {
    state.bounds = bounds;
  },
};

const actions = {
  setLandmarks({ commit }, { landmarks, bounds }) {
    commit('SET_LANDMARKS', Array.isArray(landmarks) ? landmarks : []);
    if (bounds) {
      commit('SET_LANDMARK_BOUNDS', bounds);
    }
  },
};

const getters = {
  landmarks: (state) => state.landmarks,
  bounds: (state) => state.bounds,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
